<template>
  <div id="deviceinfo">
    <div class="top">
      <div class="back" ref="back" @click="back">{{ $t("index.back") }}</div>
    </div>
    <div class="infocontent">
      <a-row :gutter="10">
        <a-col :span="24">
          <div class="card" id="info">
            <div class="card-head">
              <div class="card_title">故障次数统计</div>
              <div>
                <!-- <a-form-item label="故障类型：" name="Time">
                  <a-radio-group
                    v-model:value="timeValue"
                    button-style="solid"
                    @change="selectTime()"
                  >
                    <a-radio-button
                      v-for="time in timeList"
                      :key="time.key"
                      :value="time.key"
                    >
                      {{ time.name }}</a-radio-button
                    >
                  </a-radio-group>
                </a-form-item> -->
              </div>
            </div>
            <div class="card-content">
              <div class="sum_number_item">
                <a-spin :spinning="tabLoadingTime" size="large">
                  <div ref="chartBoxTime" style="width: 100%; height: 34vh"></div>
                </a-spin>
              </div>
            </div>
          </div>
        </a-col>
        <a-col :span="24">
          <div class="card" id="info">
            <div class="card-head">
              <div class="card_title">故障时间统计</div>
              <div>
                <a-select
                  v-model:value="selectValue"
                  show-search
                  placeholder="Select a person"
                  style="width: 200px"
                  :options="options"
                  @change="handleChange"
                >
                </a-select>
              </div>
            </div>
            <div class="card-content">
              <div class="sum_number_item">
                <a-spin :spinning="tabLoading" size="large">
                  <div ref="chartBox" style="width: 100%; height: 34vh"></div>
                </a-spin>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script setup>
import { h, ref, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { message } from "ant-design-vue";
import { useI18n } from "vue-i18n";
import * as echarts from "echarts";

const { t } = useI18n();
let router = useRouter();
let userId = ref(localStorage.getItem("userId") || "");
console.log("userId:", userId.value);
const timeList = [
  { key: "Num", name: "次数" },
  { key: "Date", name: "日期" },
];
const timeValue = ref("Num");
//点击快速查看
function selectTime() {
  console.log("点击快速查看：", timeValue.value);
}
const options = ref([]);
const selectValue = ref(undefined);
const ComponentId = ref("");

// 图标
const chartData = ref({
  xData: [],
  yData: [],
});
const tabLoadingTime = ref(false); //echarts图故障次数是否加载
const tabLoading = ref(false); //echarts图是否加载\

let chartBox = ref(null); //故障时间统计
let myEcharts = echarts;

onMounted(() => {
  //获取备件信息
  getDeviceInfo();
  //获取故障次数
  getSummaryNum();
  //获取故障时间
  getSummaryDate();
});

//选择下拉框
const handleChange = (val) => {
  console.log("选择下拉框：", val);
  ComponentId.value = val;
  //获取故障时间
  getSummaryDate();
};

//获取备件信息
const getDeviceInfo = () => {
  let params = {};
  axios
    .post("api/Component/GetList", params)
    .then(function (response) {
      console.log("备件信息:", response.data);
      if (response.data.code == 200 && response.data.ReturnType == true) {
        let data = response.data.ReturnData;
        console.log("备件信息==:", data);
        if (data != null && data.length > 0) {
          let optionsArr = [];
          for (var i = 0; i < data.length; i++) {
            let optObj = {
              value: data[i].Id,
              label: data[i].Name,
            };
            optionsArr.push(optObj);
          }
          options.value = optionsArr;
          console.log("备件信息options:", options.value);
        }
      } else {
        message.error(response.data.info);
      }
    })
    .catch(function (error) {
      message.error("备件信息获取失败，请检查网络");
    });
};

//获取故障次数
const getSummaryNum = () => {
  tabLoadingTime.value = true;
  let params = {
    // UserId: "00108764-9304-43b8-83ba-5ee77fd772de",
    UserId: userId.value,
  };
  axios
    .post("api/ComponentUserNumber/GetComponentTypeNumber", params)
    .then(function (response) {
      if (response.data.code == 200 && response.data.ReturnType == true) {
        let data = response.data.ReturnData;
        let DataArr = [];
        if (data != null && data.length > 0) {
          DataArr = data.map((item) => {
            return [item.Name, item.SumNumber];
          });
          //故障次数统计
          initChartTime(DataArr);
        } else {
          //故障次数统计
          initChartTime(DataArr);
        }
      } else {
        message.error(response.data.info);
      }
    })
    .catch(function (error) {
      message.error("故障次数获取失败，请检查网络");
    })
    .finally(() => {
      tabLoadingTime.value = false;
    });
};

//获取故障时间
const getSummaryDate = () => {
  tabLoading.value = true;
  let params = {
    // UserId: "00108764-9304-43b8-83ba-5ee77fd772de",
    UserId: userId.value,
    ComponentId: ComponentId.value,
  };
  axios
    .post("api/ComponentUserNumber/GetComponentTypeDate", params)
    .then(function (response) {
      console.log("故障时间统计:", response.data);
      if (response.data.code == 200 && response.data.ReturnType == true) {
        let data = response.data.ReturnData;
        let DataArr = [];
        if (data != null && data.length > 0) {
          // DataArr = data.map((item) => {
          //   return [item.Name, item.SumDate];
          // });
          let xData = data.map((item) => item.date);
          let yData = new Array();
          data[0].list.forEach((obj, index) => {
            let yObj = {
              name: obj.Name || "",
              data: data.map((item) => item.list.find((u) => u.Name == obj.Name).count),

              type: "bar",
              barWidth: "30",
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "rgba(" + index + ", " + index + "17, 2" + index + "5, 1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(" + index + ", " + index + "17, 2" + index + "5, 0)",
                  },
                ]),
              },
            };
            yData.push(yObj);
          });
          chartData.value.xData = xData;
          chartData.value.yData = yData;
          console.log("故障时间fanhui:", chartData.value.yData);
        } else {
          chartData.value.xData = [];
          chartData.value.yData = [];
          console.log("没有数据：", chartData.value);
          let xData = [];
          let yData = [];
        }
      } else {
        message.error(response.data.info);
      }
    })
    .catch(function (error) {
      message.error("故障时间获取失败，请检查网络");
    })
    .finally(() => {
      tabLoading.value = false;
      initChart();
    });
};

/**返回主页面 */
function back() {
  router.push(`/index/repair`);
}

let chart;
//渲染图表
function initChart() {
  console.log("yData:", chartData.value.yData);
  let option;
  option = {
    backgroundColor: "",
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      left: "3%",
      right: "1%",
      bottom: "5%",
      top: "2%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: chartData.value.xData,
        axisTick: {
          alignWithLabel: true,
        },
        // 设置所有标签都显示
        axisLabel: {
          interval: 0,
          textStyle: {
            color: "#000000",
          },
          fontSize: 12,
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        axisLabel: {
          textStyle: {
            color: "#000000",
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "rgba(217,231,255,0.3)",
          },
        },
      },
    ],
    series: chartData.value.yData,
  };
  if (chartBox.value) {
    // chart.dispose(); //销毁
    if (chart != null && chart != "" && chart != undefined) {
      chart.dispose(); //销毁
    }
    chart = myEcharts.init(chartBox.value, null, {
      renderer: "svg",
    });
    option && chart.setOption(option);
    window.onresize = function () {
      chart.resize();
    };
  }
}

/***********************故障与次数统计*************************/

let chartBoxTime = ref(null); //加工时长统计
let myEchartsTime = echarts;
function initChartTime(Data) {
  let optionTime;
  optionTime = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      top: "2%",
      left: "3%",
      right: "1%",
      bottom: "20%",
    },
    dataset: [
      {
        dimensions: ["name", "score"],
        source: Data,
      },
      {
        transform: {
          type: "sort",
          config: { dimension: "score", order: "desc" },
        },
      },
    ],
    xAxis: {
      type: "category",
      // 这个可以设置x轴标签的倾斜角度，好显示更多的文字内容
      axisLabel: { interval: 0, rotate: 10 },
    },
    yAxis: {},
    series: {
      type: "bar",
      barWidth: "30",
      itemStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "rgba(0, 137, 255, 1)" },
          { offset: 1, color: "rgba(0, 137, 255, 0)" },
        ]),
      },
      encode: { x: "name", y: "score" },
      datasetIndex: 1,
    },
  };
  if (chartBoxTime.value) {
    let chart = myEchartsTime.init(chartBoxTime.value, null, {
      renderer: "svg",
    });

    optionTime && chart.setOption(optionTime);
    window.onresize = function () {
      chart.resize();
    };
  }
}
</script>

<style scoped>
#deviceinfo {
  width: 100%;
  height: 100%;
  padding: 0px 0px;
  background-color: #f7f9fa;
  position: relative;
}
.top {
  width: 100%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background-color: white;
  color: black;
  font-weight: bold;
  font-size: 18px;
  position: relative;
  color: #fac858;
}
.back {
  height: 100%;
  line-height: 50px;
  color: #5470c6;
  cursor: pointer;
  position: absolute;
  left: 25px;
}
.infocontent {
  width: 100%;
  padding: 25px 10px 25px 25px;
}
.card {
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  margin-bottom: 15px;
  height: auto;
  overflow: visible;
  transition: all 0.4s;
  font-size: 14px;
  background-color: white;
  width: 100%;
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card-head {
  width: 100%;
  align-items: center;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
}
.card-content {
  width: 100%;
  min-height: 50px;
  padding: 15px;
}
.card_title {
  font-weight: bold;
}
</style>
